<template>
  <v-card>
    <v-card-title class="text-h5">
      Tietosuojaseloste
    </v-card-title>
    <v-card-text>
      <p class="mt-4">
        <b>Rekisterinpitäjä:</b><br>
        {{ companyName }}
      </p>
      <p>
        <b>Henkilötietojen käsittelijä:</b><br>
        RMR Holding Oy / Helmi-kiinteistönvälitysjärjestelmä<br>
        Männistönkatu 7<br>
        26100 Rauma<br>
        y-tunnus: 2402115-6
      </p>
      <p>
        <b>Henkilötietojen käsittelyyn liittyvät yhteydenotot:</b><br>
        tekniikka@rmr.fi
      </p>
      <p>
        <b>Henkilötietojen käsittelyn käyttötarkoitus:</b><br>
        Keräämme henkilötietoja rekisterinpitäjän (jäljempänä yritys) asiakassuhteen hoitamista
        varten. Henkilötietojen käsittelyn oikeusperusteena on käyttäjän ja yrityksen välinen
        sopimus ja siitä johtuvat lakisääteiset velvoitteet. Henkilötietojen antaminen on edellytys
        sopimuksen syntymiselle. Toisin sanoen et voi täyttää yrityksen sähköisiä lomakkeita
        antamatta henkilötietojasi (nimi, sosiaaliturvatunnus, puhelinnumero ja yhteystiedot).
        Emme tee henkilötietoja koskevia profilointeja tai automaattisia päätöksiä.
      </p>
      <p>
        <b>Henkilötietojasi vastaanottavat:</b><br>
        <ul>
          <li>sinä itse</li>
          <li>rekisterinpitäjä</li>
          <li>henkilötietojen käsittelijä</li>
          <li>Mandrill-sähköpostinvälityspalvelu</li>
        </ul>
        <br>
        Tarjouskohteen luonteesta riippuen henkilötietojasi voivat saada toinen kauppaosapuoli,
        pankit tai rahoituslaitokset, isännöintitoimistot, huoneistojärjestelmät,
        osakehuoneistorekisterit, maanmittauslaitos, kaupanvahvistaja, kiinteistötietojärjestelmät,
        vuokraoikeuden omistajatahot.
        <br><br>
        Yritys on velvollinen pyytämään sinulta erikseen suostumuksen mikäli henkilötietojasi
        välitetään jollekin muulle kuin edellä mainituille osapuolelle. Henkilötietojen käsittelijän
        tarjoama tietojärjestelmä on suojattu yritystoiminnassa normaalisti käytössä olevilla
        teknisillä suojausmenetelmillä. Rekisterin käyttöoikeus edellyttää yrityksen työntekijöiltä
        henkilökohtaista käyttäjätunnusta ja kirjautumista.
      </p>
      <p>
        <b>Henkilötietojesi säilytysaika:</b><br>
        Rekisterinpitäjä säilyttää tietojasi viiden vuoden ajan viimeisen palvelupyyntösi
        jälkeen. Mikäli teet uuden palvelupyynnön, alkaa tämä ajan laskenta alusta.
      </p>
      <p>
        <b>Sinulla on seuraavat oikeudet:</b><br>
        <ul>
          <li>Oikeus tarkastaa itseäsi koskevat henkilötiedot</li>
          <li>Oikeus tietojen oikaisemiseen</li>
          <li>Oikeus käsittelyn rajoittamiseen</li>
          <li>Oikeus vastustaa käsittelyä</li>
          <li>Oikeus peruuttaa suostumus</li>
          <li>Oikeus tehdä valitus valvontaviranomaiselle</li>
        </ul>
        <br>
        Huomioithan, että sinulla on oikeus tulla unohdetuksi vain, jos meillä ei ole
        lakisääteisiä velvoitteita jatkaa henkilötietojesi käsittelyä.
      </p>
    </v-card-text>
  </v-card>
</template>
<script>
import { apiGet } from '../api';

export default {
  name: 'Gdpr',
  data: () => ({
    companyName: '',
  }),
  async mounted() {
    const response = await apiGet(`properties/getcompanyname/${this.$route.params.id}`);
    this.companyName = response.result.name;
  },
};
</script>
